
import { defineComponent } from "vue";

import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";
import { AccordianState } from "@/types";

export default defineComponent({
  name: "ToolTitle",
  components: {
    CloseSVG,
  },
  props: {
    title: String,
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    fadeTools(): void {
      const PAYLOAD: AccordianState = { isOpen: false, tool: "", key: 0 };

      this.$store.dispatch(ActionTypes.SET_ACCORDIAN_STATE, PAYLOAD);
    },
  },
});
